import { articles, type Article } from '@/mocks/articles';
import { categories, type CategoryMeta } from '@/mocks/categories';

export const allArticles: Article[] = articles;
export const allCategories: CategoryMeta[] = categories;

export function getCategory(slug: string): CategoryMeta | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getLatestArticles(limit?: number): Article[] {
  const sorted = [...articles].sort((a, b) => b.publishedAt.localeCompare(a.publishedAt));
  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
}

export function getHotArticles(limit?: number): Article[] {
  const sorted = [...articles].sort((a, b) => b.views - a.views);
  return typeof limit === 'number' ? sorted.slice(0, limit) : sorted;
}

export function getArticlesByCategory(slug: string): Article[] {
  return articles.filter((a) => a.category === slug);
}

export function getRelatedArticles(article: Article, limit = 4): Article[] {
  const sameCat = articles.filter((a) => a.category === article.category && a.id !== article.id);
  const sorted = sameCat.sort((a, b) => b.views - a.views);
  if (sorted.length >= limit) return sorted.slice(0, limit);
  const fill = getHotArticles().filter(
    (a) => a.id !== article.id && !sorted.some((s) => s.id === a.id),
  );
  return [...sorted, ...fill].slice(0, limit);
}

export function searchArticles(keyword: string): Article[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return articles.filter((a) => {
    const haystack = [a.title, a.summary, a.sub, a.categoryName, a.source, a.tags.join(' ')]
      .join(' ')
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return String(views);
}

export function formatDate(publishedAt: string): string {
  return publishedAt.slice(0, 10);
}

export function formatTime(publishedAt: string): string {
  return publishedAt.slice(11, 16);
}